import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Calendar, ArrowLeft } from 'lucide-react';

const BlogPost = () => {
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadBlogPost();
        window.scrollTo(0, 0); // Scroll to top when component mounts
    }, [id]);

    const loadBlogPost = async () => {
        try {
            setLoading(true);
            const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
            const response = await fetch(`${BACKEND_URL}/api/blog/${id}`);

            if (!response.ok) {
                throw new Error('Blog yazısı bulunamadı');
            }

            const data = await response.json();
            setPost(data);
        } catch (error) {
            console.error('Failed to load blog post:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-700"></div>
            </div>
        );
    }

    if (error || !post) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                    {error || 'Blog yazısı bulunamadı'}
                </h2>
                <Link
                    to="/blog"
                    className="bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition"
                >
                    Blog'a Dön
                </Link>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 pb-20">
            {/* Hero Image Section */}
            <div className="relative h-[400px] w-full">
                <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute bottom-0 left-0 w-full p-8 md:p-12">
                    <div className="max-w-4xl mx-auto">
                        <Link
                            to="/blog"
                            className="inline-flex items-center text-white/80 hover:text-white mb-6 transition"
                        >
                            <ArrowLeft className="h-5 w-5 mr-2" />
                            Blog'a Dön
                        </Link>
                        <div className="flex items-center gap-4 text-white/90 mb-4">
                            <span className="bg-emerald-600 px-3 py-1 rounded text-sm font-medium">
                                {post.category}
                            </span>
                            <span className="flex items-center gap-1 text-sm">
                                <Calendar className="h-4 w-4" />
                                {post.date}
                            </span>
                        </div>
                        <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight">
                            {post.title}
                        </h1>
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10 relative z-10">
                <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
                    <div className="prose prose-lg max-w-none text-gray-700">
                        {/* 
              If the content is HTML, use dangerouslySetInnerHTML. 
              If it's plain text with newlines, we might want to split by newline and render paragraphs.
              Assuming simple text or HTML for now. 
            */}
                        {post.content.split('\n').map((paragraph, idx) => (
                            paragraph.trim() && <p key={idx} className="mb-4">{paragraph}</p>
                        ))}
                    </div>
                </div>

                {/* Share/Footer Section */}
                <div className="mt-12 text-center">
                    <h3 className="text-xl font-semibold text-gray-800 mb-6">
                        Bu yazıyı faydalı buldunuz mu?
                    </h3>
                    <Link
                        to="/iletisim"
                        className="inline-block bg-emerald-600 text-white px-8 py-4 rounded-xl font-bold hover:bg-emerald-700 hover:shadow-lg transition transform hover:-translate-y-1"
                    >
                        Bize Ulaşın
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default BlogPost;
